import React from "react";

import classnames from "classnames";

const iconLayouts = color => ({
  profile: (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5 2.375C10.0872 2.375 10.6611 2.54911 11.1494 2.87532C11.6376 3.20153 12.0181 3.66519 12.2428 4.20766C12.4675 4.75013 12.5263 5.34704 12.4117 5.92292C12.2972 6.49881 12.0144 7.02779 11.5992 7.44297C11.184 7.85816 10.6551 8.14091 10.0792 8.25546C9.5033 8.37001 8.90638 8.31122 8.36391 8.08652C7.82144 7.86182 7.35779 7.48131 7.03158 6.9931C6.70537 6.50489 6.53125 5.93091 6.53125 5.34375C6.53125 4.55639 6.84403 3.80128 7.40078 3.24453C7.95753 2.68778 8.71264 2.375 9.5 2.375ZM9.5 1.1875C8.67797 1.1875 7.8744 1.43126 7.19091 1.88795C6.50742 2.34465 5.9747 2.99377 5.66013 3.75322C5.34555 4.51268 5.26324 5.34836 5.42361 6.15459C5.58398 6.96083 5.97983 7.7014 6.56109 8.28266C7.14235 8.86392 7.88292 9.25977 8.68916 9.42014C9.49539 9.58051 10.3311 9.4982 11.0905 9.18362C11.85 8.86905 12.4991 8.33633 12.9558 7.65284C13.4125 6.96935 13.6563 6.16578 13.6563 5.34375C13.6563 4.24144 13.2184 3.18429 12.4389 2.40484C11.6595 1.62539 10.6023 1.1875 9.5 1.1875Z"
        fill={color}
      />
      <path
        d="M15.4375 15.6071H14.25V14.8438C14.25 14.4539 14.1732 14.0678 14.024 13.7077C13.8748 13.3475 13.6561 13.0202 13.3805 12.7445C13.1048 12.4689 12.7775 12.2502 12.4173 12.101C12.0572 11.9518 11.6711 11.875 11.2812 11.875H7.71875C6.93139 11.875 6.17628 12.1878 5.61953 12.7445C5.06278 13.3013 4.75 14.0564 4.75 14.8438V15.6071H3.5625V14.8438C3.5625 13.7414 4.00039 12.6843 4.77984 11.9048C5.55929 11.1254 6.61644 10.6875 7.71875 10.6875H11.2812C12.3836 10.6875 13.4407 11.1254 14.2202 11.9048C14.9996 12.6843 15.4375 13.7414 15.4375 14.8438V15.6071Z"
        fill={color}
      />
    </svg>
  ),
  share: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.2585 3.45364L4.13346 6.51614L3.74146 5.73389L9.86645 2.67139L10.2585 3.45364ZM9.86645 11.3286L3.74146 8.26614L4.13346 7.48389L10.2585 10.5464L9.86645 11.3286Z"
        fill={color}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.8125 3.5C12.1606 3.5 12.4944 3.36172 12.7406 3.11558C12.9867 2.86944 13.125 2.5356 13.125 2.1875C13.125 1.8394 12.9867 1.50556 12.7406 1.25942C12.4944 1.01328 12.1606 0.875 11.8125 0.875C11.4644 0.875 11.1306 1.01328 10.8844 1.25942C10.6383 1.50556 10.5 1.8394 10.5 2.1875C10.5 2.5356 10.6383 2.86944 10.8844 3.11558C11.1306 3.36172 11.4644 3.5 11.8125 3.5ZM11.8125 4.375C12.3927 4.375 12.9491 4.14453 13.3593 3.7343C13.7695 3.32406 14 2.76766 14 2.1875C14 1.60734 13.7695 1.05094 13.3593 0.640704C12.9491 0.230468 12.3927 0 11.8125 0C11.2323 0 10.6759 0.230468 10.2657 0.640704C9.85547 1.05094 9.625 1.60734 9.625 2.1875C9.625 2.76766 9.85547 3.32406 10.2657 3.7343C10.6759 4.14453 11.2323 4.375 11.8125 4.375ZM11.8125 13.125C12.1606 13.125 12.4944 12.9867 12.7406 12.7406C12.9867 12.4944 13.125 12.1606 13.125 11.8125C13.125 11.4644 12.9867 11.1306 12.7406 10.8844C12.4944 10.6383 12.1606 10.5 11.8125 10.5C11.4644 10.5 11.1306 10.6383 10.8844 10.8844C10.6383 11.1306 10.5 11.4644 10.5 11.8125C10.5 12.1606 10.6383 12.4944 10.8844 12.7406C11.1306 12.9867 11.4644 13.125 11.8125 13.125ZM11.8125 14C12.3927 14 12.9491 13.7695 13.3593 13.3593C13.7695 12.9491 14 12.3927 14 11.8125C14 11.2323 13.7695 10.6759 13.3593 10.2657C12.9491 9.85547 12.3927 9.625 11.8125 9.625C11.2323 9.625 10.6759 9.85547 10.2657 10.2657C9.85547 10.6759 9.625 11.2323 9.625 11.8125C9.625 12.3927 9.85547 12.9491 10.2657 13.3593C10.6759 13.7695 11.2323 14 11.8125 14ZM2.1875 8.3125C2.5356 8.3125 2.86944 8.17422 3.11558 7.92808C3.36172 7.68194 3.5 7.3481 3.5 7C3.5 6.6519 3.36172 6.31806 3.11558 6.07192C2.86944 5.82578 2.5356 5.6875 2.1875 5.6875C1.8394 5.6875 1.50556 5.82578 1.25942 6.07192C1.01328 6.31806 0.875 6.6519 0.875 7C0.875 7.3481 1.01328 7.68194 1.25942 7.92808C1.50556 8.17422 1.8394 8.3125 2.1875 8.3125ZM2.1875 9.1875C2.76766 9.1875 3.32406 8.95703 3.7343 8.5468C4.14453 8.13656 4.375 7.58016 4.375 7C4.375 6.41984 4.14453 5.86344 3.7343 5.4532C3.32406 5.04297 2.76766 4.8125 2.1875 4.8125C1.60734 4.8125 1.05094 5.04297 0.640704 5.4532C0.230468 5.86344 0 6.41984 0 7C0 7.58016 0.230468 8.13656 0.640704 8.5468C1.05094 8.95703 1.60734 9.1875 2.1875 9.1875Z"
        fill={color}
      />
    </svg>
  ),
  key: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 1.00006C9.30653 1.00006 8.16193 1.47417 7.31802 2.31808C6.47411 3.16199 6 4.30659 6 5.50006C5.99956 5.94235 6.06529 6.38222 6.195 6.80506L1 12.0001V15.0001H4L9.195 9.80506C9.83827 10.0024 10.5176 10.053 11.183 9.95315C11.8484 9.85326 12.483 9.60542 13.0399 9.22788C13.5969 8.85033 14.0621 8.35269 14.4013 7.77158C14.7405 7.19047 14.9451 6.54069 15 5.87006C15.1009 4.80284 14.8075 3.7356 14.175 2.87006C13.7558 2.28804 13.2036 1.81465 12.5643 1.48936C11.925 1.16408 11.2173 0.996315 10.5 1.00006ZM10.5 9.00006C10.1612 8.99873 9.82432 8.9482 9.5 8.85006L8.925 8.67506L8.5 9.10006L6.91 10.6901L6.205 10.0001L5.5 10.7051L6.19 11.3951L5.395 12.1901L4.705 11.5001L4 12.2051L4.69 12.8951L3.585 14.0001H2V12.4151L6.9 7.50006L7.325 7.07506L7.18 6.60006C6.92835 5.80873 6.96043 4.95442 7.27071 4.18419C7.581 3.41395 8.15008 2.77597 8.88 2.38006C9.40582 2.10518 9.99288 1.96849 10.586 1.98283C11.1792 1.99716 11.759 2.16205 12.2709 2.46201C12.7828 2.76196 13.2101 3.18713 13.5125 3.69758C13.815 4.20802 13.9828 4.78698 14 5.38006C14.0347 6.08762 13.8439 6.78792 13.455 7.38006C13.1386 7.87695 12.7019 8.28593 12.1853 8.56912C11.6688 8.8523 11.0891 9.00053 10.5 9.00006Z"
        fill={color}
      />
      <path
        d="M11 6C11.5523 6 12 5.55228 12 5C12 4.44772 11.5523 4 11 4C10.4477 4 10 4.44772 10 5C10 5.55228 10.4477 6 11 6Z"
        fill={color}
      />
    </svg>
  ),
  userCheck: (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.625 6.25C3.90188 6.25 2.5 4.84813 2.5 3.125C2.5 1.40188 3.90188 0 5.625 0C7.34813 0 8.75 1.40188 8.75 3.125C8.75 4.84813 7.34813 6.25 5.625 6.25ZM5.625 0.625C4.24625 0.625 3.125 1.74625 3.125 3.125C3.125 4.50375 4.24625 5.625 5.625 5.625C7.00375 5.625 8.125 4.50375 8.125 3.125C8.125 1.74625 7.00375 0.625 5.625 0.625Z"
        fill={color}
      />
      <path
        d="M4.0625 13.125H0.3125C0.14 13.125 0 12.985 0 12.8125V10.3125C0 8.76188 1.26188 7.5 2.8125 7.5H8.4375C9.20438 7.5 9.9425 7.81562 10.4644 8.36625C10.5831 8.49125 10.5781 8.68938 10.4525 8.80813C10.3275 8.9275 10.1294 8.92188 10.0106 8.79625C9.60688 8.37 9.03312 8.125 8.4375 8.125H2.8125C1.60625 8.125 0.625 9.10625 0.625 10.3125V12.5H4.0625C4.235 12.5 4.375 12.64 4.375 12.8125C4.375 12.985 4.235 13.125 4.0625 13.125Z"
        fill={color}
      />
      <path
        d="M9.0625 15C8.94438 15 8.83625 14.9337 8.78313 14.8275L7.61937 12.5H5.9375C5.765 12.5 5.625 12.36 5.625 12.1875C5.625 12.015 5.765 11.875 5.9375 11.875H7.8125C7.93062 11.875 8.03875 11.9419 8.09187 12.0475L9.04063 13.945L10.65 10.1894C10.6981 10.0775 10.8063 10.0037 10.9281 10C11.0488 10.0044 11.1625 10.0637 11.2169 10.1725L13.0056 13.75H14.6875C14.86 13.75 15 13.89 15 14.0625C15 14.235 14.86 14.375 14.6875 14.375H12.8125C12.6944 14.375 12.5862 14.3081 12.5331 14.2025L10.9594 11.055L9.35 14.8106C9.30188 14.9225 9.19375 14.9962 9.07188 15C9.06875 15 9.06562 15 9.0625 15Z"
        fill={color}
      />
    </svg>
  ),
  pcpRequest: (
    <svg
      width="19"
      height="19"
      viewBox="0 0 84 84"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M60.3576 18.9122C60.3576 29.3572 51.8904 37.8244 41.4454 37.8244C31.0004 37.8244 22.5332 29.3572 22.5332 18.9122C22.5332 8.46717 31.0004 0 41.4454 0C51.8904 0 60.3576 8.46717 60.3576 18.9122Z"
        fill="#707070"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M71.7933 49.2397C68.2909 49.2383 64.9313 50.6275 62.4527 53.1021C59.9741 55.5766 58.5795 58.934 58.5752 62.4364C58.5752 65.9406 59.9672 69.3013 62.4451 71.7792C64.923 74.2571 68.2837 75.6491 71.7879 75.6491C75.2922 75.6491 78.6529 74.2571 81.1307 71.7792C83.6086 69.3013 85.0007 65.9406 85.0007 62.4364C84.9978 58.9354 83.6051 55.5788 81.1285 53.1043C78.652 50.6298 75.2942 49.2397 71.7933 49.2397ZM74.6687 65.2313V70.4777H69.0199V65.2313H63.5052V59.6898H69.0199V54.1858H74.6687V59.6898H79.9741V65.2313H74.6687Z"
        fill="#707070"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M49.7932 59.7587C49.7932 53.1014 52.7168 47.1307 57.3356 43.0806C59.8087 40.9026 59.6638 41.0957 57.5073 42.1418C51.2952 45.1566 42.8837 46.0364 42.8837 46.0364C42.8837 46.0364 27.2838 44.4968 22.6864 38.3169C0.665194 38.3169 0 70.3107 0 70.3107H52.4379C50.6994 67.0654 49.7908 63.4404 49.7932 59.7587Z"
        fill="#707070"
      />
    </svg>
  ),
  lock: (
    <svg
      width="105"
      height="135"
      viewBox="0 0 105 135"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M94.2029 57.5995H80.3361V41.0044C80.3361 26.38 68.4376 14.4821 53.8139 14.4821C39.1901 14.4821 27.2922 26.38 27.2922 41.0044V57.5995H13.4248V41.0044C13.4248 18.7344 31.5439 0.615295 53.8139 0.615295C76.0838 0.615295 94.2029 18.7344 94.2029 41.0044V57.5995Z"
        fill="#89ACFD"
      />
      <path
        d="M88.6264 56.9842H74.7596V40.3891C74.7596 25.7653 62.8611 13.8668 48.2367 13.8668C33.6136 13.8668 21.7151 25.7653 21.7151 40.3891V56.9842H7.84766V40.3891C7.84766 18.1191 25.9674 0 48.2367 0C70.5073 0 88.6264 18.1191 88.6264 40.3891V56.9842Z"
        fill="#D3F0FD"
      />
      <path
        d="M58.2969 134.923C33.0478 134.923 12.5791 114.454 12.5791 89.2053V61.5234C12.5791 58.9028 14.7037 56.7783 17.3243 56.7783H99.2696C101.89 56.7783 104.015 58.9028 104.015 61.5234V89.2053C104.015 114.454 83.5461 134.923 58.2969 134.923Z"
        fill="#4C81FC"
      />
      <path
        d="M45.7178 134.923C20.4687 134.923 0 114.454 0 89.2053V61.5234C0 58.9028 2.12458 56.7783 4.74517 56.7783H86.6905C89.3111 56.7783 91.4357 58.9028 91.4357 61.5234V89.2053C91.4357 114.454 70.967 134.923 45.7178 134.923Z"
        fill="#BDD1FF"
      />
      <path
        d="M45.7062 110.191C43.085 110.191 40.9617 108.067 40.9617 105.447V93.9132C37.9289 92.2323 35.8516 89.0388 35.8516 85.3266C35.8516 79.885 40.2633 75.4733 45.7062 75.4733V76.5132C42.478 78.1317 40.2633 81.4707 40.2633 85.3266C40.2633 89.0388 42.34 92.2323 45.3734 93.9132V105.447C45.3734 106.064 45.4913 106.654 45.7062 107.196V110.191Z"
        fill="#4C81FC"
      />
      <path
        d="M45.7183 107.233C45.5033 106.691 45.3855 106.102 45.3855 105.484V93.9503C42.3521 92.2694 40.2754 89.0759 40.2754 85.3637C40.2754 81.5079 42.4901 78.1688 45.7183 76.5503V107.233Z"
        fill="#001F67"
      />
      <path
        d="M47.9045 109.708C46.9061 109.183 46.1183 108.313 45.6992 107.256V76.573C46.3912 76.2258 47.1305 75.9579 47.9045 75.7808C52.2841 76.7823 55.5519 80.7031 55.5519 85.3865C55.5519 89.0987 53.4753 92.2921 50.4425 93.973V105.507C50.4425 107.331 49.4133 108.914 47.9045 109.708Z"
        fill="#001F67"
      />
    </svg>
  ),
  mail: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z"
        fill={color}
      />
    </svg>
  ),
  delete: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.4163 3.66667H14.208L13.2913 2.75H8.70801L7.79134 3.66667H4.58301V5.5H17.4163V3.66667ZM5.49967 17.4167C5.49967 17.9029 5.69283 18.3692 6.03665 18.713C6.38046 19.0568 6.84678 19.25 7.33301 19.25H14.6663C15.1526 19.25 15.6189 19.0568 15.9627 18.713C16.3065 18.3692 16.4997 17.9029 16.4997 17.4167V6.41667H5.49967V17.4167Z"
        fill={color}
      />
    </svg>
  ),
  download: (
    <svg
      width="22"
      height="22"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 15H1C0.447715 15 0 15.4477 0 16C0 16.5523 0.447715 17 1 17H15C15.5523 17 16 16.5523 16 16C16 15.4477 15.5523 15 15 15Z"
        fill={color}
      />
      <path
        d="M0 14L0 16C0 16.5523 0.447715 17 1 17C1.55228 17 2 16.5523 2 16V14C2 13.4477 1.55228 13 1 13C0.447715 13 0 13.4477 0 14Z"
        fill={color}
      />
      <path
        d="M14 14V16C14 16.5523 14.4477 17 15 17C15.5523 17 16 16.5523 16 16V14C16 13.4477 15.5523 13 15 13C14.4477 13 14 13.4477 14 14Z"
        fill={color}
      />
      <path
        d="M8.00044 12C7.79312 12.0016 7.59044 11.9387 7.42044 11.82L3.42044 9C3.20485 8.84707 3.05858 8.615 3.01361 8.35453C2.96864 8.09406 3.02862 7.82638 3.18044 7.61C3.25623 7.50185 3.35268 7.40978 3.46424 7.33911C3.57581 7.26844 3.70026 7.22056 3.83042 7.19825C3.96059 7.17594 4.09388 7.17962 4.22261 7.2091C4.35134 7.23858 4.47296 7.29327 4.58044 7.37L8.00044 9.76L11.4004 7.2C11.6126 7.04087 11.8793 6.97255 12.1419 7.01005C12.4044 7.04756 12.6413 7.18783 12.8004 7.4C12.9596 7.61218 13.0279 7.87887 12.9904 8.14143C12.9529 8.40398 12.8126 8.64087 12.6004 8.8L8.60044 11.8C8.42734 11.9298 8.21681 12 8.00044 12Z"
        fill={color}
      />
      <path
        d="M8 10C7.73478 10 7.48043 9.89464 7.29289 9.70711C7.10536 9.51957 7 9.26522 7 9V1C7 0.734784 7.10536 0.48043 7.29289 0.292893C7.48043 0.105357 7.73478 0 8 0C8.26522 0 8.51957 0.105357 8.70711 0.292893C8.89464 0.48043 9 0.734784 9 1V9C9 9.26522 8.89464 9.51957 8.70711 9.70711C8.51957 9.89464 8.26522 10 8 10Z"
        fill={color}
      />
    </svg>
  ),
  print: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      fill={color}
      class="bi bi-printer"
      viewBox="0 0 16 16"
    >
      <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z" />
      <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z" />
    </svg>
  ),
  receipt: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      fill={color}
      class="bi bi-receipt"
      viewBox="0 0 16 16"
    >
      <path d="M1.92.506a.5.5 0 0 1 .434.14L3 1.293l.646-.647a.5.5 0 0 1 .708 0L5 1.293l.646-.647a.5.5 0 0 1 .708 0L7 1.293l.646-.647a.5.5 0 0 1 .708 0L9 1.293l.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .801.13l.5 1A.5.5 0 0 1 15 2v12a.5.5 0 0 1-.053.224l-.5 1a.5.5 0 0 1-.8.13L13 14.707l-.646.647a.5.5 0 0 1-.708 0L11 14.707l-.646.647a.5.5 0 0 1-.708 0L9 14.707l-.646.647a.5.5 0 0 1-.708 0L7 14.707l-.646.647a.5.5 0 0 1-.708 0L5 14.707l-.646.647a.5.5 0 0 1-.708 0L3 14.707l-.646.647a.5.5 0 0 1-.801-.13l-.5-1A.5.5 0 0 1 1 14V2a.5.5 0 0 1 .053-.224l.5-1a.5.5 0 0 1 .367-.27zm.217 1.338L2 2.118v11.764l.137.274.51-.51a.5.5 0 0 1 .707 0l.646.647.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.646.646.646-.646a.5.5 0 0 1 .708 0l.509.509.137-.274V2.118l-.137-.274-.51.51a.5.5 0 0 1-.707 0L12 1.707l-.646.647a.5.5 0 0 1-.708 0L10 1.707l-.646.647a.5.5 0 0 1-.708 0L8 1.707l-.646.647a.5.5 0 0 1-.708 0L6 1.707l-.646.647a.5.5 0 0 1-.708 0L4 1.707l-.646.647a.5.5 0 0 1-.708 0l-.509-.51z" />
      <path d="M3 4.5a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 1 1 0 1h-6a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zm8-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5z" />
    </svg>
  ),
  danger: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      fill="#DC3545"
      class="bi bi-x-circle"
      viewBox="0 0 16 16"
    >
      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
      <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
    </svg>
  ),
});

const ProfileIcon = ({ onClick, className, type }) => {
  const icon = iconLayouts("var(--icon-color)")[type];
  return <span className={classnames("mr-2", className)}>{icon}</span>;
};

export default ProfileIcon;
